<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store";

export default {
  name: "LayoutView",
  components: {},
  computed: {
    ...mapState(useMainStore, {
      ranges: (store) => store.ranges,
    }),
  },
  mounted() {
    this.getRanges();
  },
  methods: {
    getRanges() {
      if (!Object.keys(this.ranges).length) {
        this.fetchData();
      }
    },
    ...mapActions(useMainStore, ["fetchData"]),
  },
};
</script>

<style lang="scss" scoped></style>
